import styled from 'styled-components';

export const StyledCoinNumCol = styled.td`
   
`